import './assets/main.css';
import './firebase';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'katex/dist/katex.min.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import { initSentry } from '@/observability/sentry';
import { initAnalytics } from '@/observability/posthog';
import { initMetaPixel } from '@/observability/metaPixel';
import { bindAnalyticsBoardContext } from '@/observability/identity';
import { canonicalRedirectUrl } from '@/utils/canonicalHost';

function bootstrap() {
  const app = createApp(App);

  // Must run before mount so Sentry can hook Vue's error handler. No-op when
  // VITE_SENTRY_DSN is unset (local dev).
  initSentry(app, router);

  // Product analytics (PIX-551). Same contract: no-op when VITE_POSTHOG_KEY is
  // unset, so developer activity never reaches a real project.
  initAnalytics(router);

  // Browser conversion tracking. No-op outside production, where the Pixel ID
  // is deliberately left unset.
  initMetaPixel(router);

  app.use(createPinia());

  // Board is the breakdown nearly every metric is sliced by, and it changes
  // independently of the user. Must run after Pinia is installed.
  bindAnalyticsBoardContext();

  app.use(router);

  app.mount('#app');

  AOS.init({
    duration: 500,
    once: true, // animation happens only once
  });
}

// Send the Firebase default hostnames to the real domain before anything else
// happens (PIX-628). This is deliberately the first thing in the file and the
// app is deliberately NOT booted when it fires: `location.replace` does not
// stop the current script, so booting anyway would let initAnalytics emit a
// pageview from the origin we are in the middle of leaving - which is the
// person-splitting this exists to prevent, on the very visit meant to fix it.
const canonicalUrl = canonicalRedirectUrl(window.location);
if (canonicalUrl) {
  window.location.replace(canonicalUrl);
} else {
  bootstrap();
}
